import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';

interface Props {
  isEditable?: boolean;
  onAddModel(): void;
}

export const ModelGroupEmpty: React.FC<Props> = ({ isEditable, onAddModel }) => {
  return (
    <Box display="flex" py="24">
      <Text fontWeight={500} color="neutral.500">
        You haven’t added any items yet.
      </Text>

      {isEditable && (
        <>
          <Button variant="link" onClick={onAddModel} mx="2">
            Add a model
          </Button>

          <Text fontWeight={500} color="neutral.500">
            to get started.
          </Text>
        </>
      )}
    </Box>
  );
};
